import { ComponentProps } from 'react';

import { Section } from './variants/Section';

const variants = {
  section: Section,
};

type VariantSectionProps = ComponentProps<typeof Section> & {
  variant?: 'section';
};

type AccordionProps = VariantSectionProps;

function Accordion({ variant = 'section', ...props }: AccordionProps) {
  const AccordionVariant = variants[variant];

  return <AccordionVariant {...props} />;
}

Accordion.Section = Section;

export { Accordion };
